import C from "@/store/constants";

const VB_SERVICE_NAME = C.service.VB_SERVICE;

export default {
  namespaced: true,

  actions: {
    listModels({ dispatch }) {
      return new Promise(function (resolve, reject) {
        dispatch("API", VB_SERVICE_NAME, { root: true })
          .then((api) => api.get("/ai/models"))
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    listPrompts({ dispatch }) {
      return new Promise(function (resolve, reject) {
        dispatch("API", VB_SERVICE_NAME, { root: true })
          .then((api) => api.get("/ai/prompts"))
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    getPrompt({ dispatch }, id) {
      return new Promise(function (resolve, reject) {
        dispatch("API", VB_SERVICE_NAME, { root: true })
          .then((api) => api.get(`/ai/prompts/${encodeURIComponent(id)}`))
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    savePrompt({ dispatch }, prompt) {
      return new Promise(function (resolve, reject) {
        dispatch("API", VB_SERVICE_NAME, { root: true })
          .then((api) => {
            if (prompt?.id) {
              return api.put(
                `/ai/prompts/${encodeURIComponent(prompt.id)}`,
                prompt
              );
            }
            return api.post("/ai/prompts", prompt);
          })
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    deletePrompt({ dispatch }, id) {
      return new Promise(function (resolve, reject) {
        dispatch("API", VB_SERVICE_NAME, { root: true })
          .then((api) => api.delete(`/ai/prompts/${encodeURIComponent(id)}`))
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    promptTemplate({ dispatch }, { inspection, object, id, data }) {
      return new Promise(function (resolve, reject) {
        dispatch("API", VB_SERVICE_NAME, { root: true })
          .then((api) =>
            api.post(
              `/inspections/${inspection}/objects/${object}/prompt/${id}`,
              data
            )
          )
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    restoreContext({ dispatch }, { inspection, object, remark }) {
      return new Promise(function (resolve, reject) {
        dispatch("API", VB_SERVICE_NAME, { root: true })
          .then((api) =>
            api.get(
              `/inspections/${inspection}/objects/${object}/${remark}/prompt`
            )
          )
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    clearContext({ dispatch }, { inspection, object, remark }) {
      return new Promise(function (resolve, reject) {
        dispatch("API", VB_SERVICE_NAME, { root: true })
          .then((api) =>
            api.delete(
              `/inspections/${inspection}/objects/${object}/${remark}/prompt`
            )
          )
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    prompt({ dispatch }, { inspection, object, remark, request }) {
      return new Promise(function (resolve, reject) {
        dispatch("API", VB_SERVICE_NAME, { root: true })
          .then((api) =>
            api.post(
              `/inspections/${inspection}/objects/${object}/${remark}/prompt`,
              request
            )
          )
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    transcribe({ dispatch }, file) {
      return new Promise(function (resolve, reject) {
        dispatch("API", VB_SERVICE_NAME, { root: true })
          .then((api) =>
            api.post("/whisper", file, {
              headers: { "Content-Type": "multipart/form-data" },
            })
          )
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
  },
};
